import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Categories from './components/Categories';
import ContentSections from './components/ContentSections';
import PillarArticles from './components/PillarArticles';
import Faq from './components/Faq';
import useHashScroll from '@/hooks/useHashScroll';

const SITE_URL = import.meta.env.VITE_SITE_URL;

export default function Home() {
  const { t } = useTranslation();
  useHashScroll();

  const faqItems = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'WebSite', name: 'USFansSheet.help', url: `${SITE_URL}/` },
      { '@type': 'Organization', name: 'USFansSheet.help', url: `${SITE_URL}/` },
      {
        '@type': 'FAQPage',
        mainEntity: faqItems.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <ContentSections />
        <PillarArticles />
        <Faq />
      </main>
      <Footer />
    </>
  );
}